export const SESSION_EXPIRATION_INITIAL_STATE = {
  timeToKill: -1,
  expiresAt: -1,
};
